import { Organization, OrganizationMember  } from './organization';

export class User {
    public success: boolean = false;

    token: string | null = null;
    lastUpdateFromServer: Date | null = null;
    id: number = 0;
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    birthday: string = '';
    gender: string = '';
    addrStreet: string = '';
    addrPostalcode: string = '';
    addrCity: string = '';
    addrCountry: string = '';
    phoneNumber: string = '';
    identifier: string = '';
    languageCode: string | null = null;
    publicPageIsActive: boolean = false;
    postDefaultVisiblity: string = '2';
    isVisibleOnSearch: boolean = false;

    avatarNewFileName: string | null = null;
    avatar: string = '';
    avatarBase64: string | null = null;

    organization: Organization | null = null;
    organizationMember: OrganizationMember | null = null;

    getInitial() {
        var ret = ""

        if(this.firstName != null && this.firstName.length > 0)
            ret += this.firstName[0].toUpperCase();
        if(this.lastName != null && this.lastName.length > 0)
            ret += this.lastName[0].toUpperCase();
        return ret;
    }
}

export class Friend {
    id: number | null = null;
    isConfirmedByFriend: boolean = false;
    user: User | null = null;
    friend: User | null = null;
    friendIsFollowed: boolean = false;
}

export class Follow {
    id: number | null = null;
    isNotif: boolean = true;
    user: User | null = null;
    follow: User | null = null;
    followIsFriend: boolean = false;
}